

























import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import SideMenu from '@/components/SideMenu.vue';
import api from '@/api'
import constants from '@/utils/constants'
import LoadingWithText from '@/components/LoadingWithText.vue'
@Component({
  components: {
    LoadingWithText,
    Header,
    SideMenu
  }
})
export default class DashView extends Vue {
  toggle: boolean = false;
  isMobile: boolean = false;
  isAdmin: boolean = this.userType === 'Admin';
  fetching: boolean = false;
  $swal: any;

  public updateToggle() {
    this.toggle = !this.toggle;
  }

  beforeMount() {
    this.listenScreenChange();
    window.addEventListener('resize', this.listenScreenChange);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.listenScreenChange);
  }

  get onAndroidApp() {
    return window && typeof (window as any).android !== 'undefined'
  }

  get userUid() {
    return localStorage.getItem('UID');
  }

  get userType() {
    return this.$store.state.currentUser
      ? this.$store.state.currentUser.Type
      : '';
  }

  settingPrinters() {
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.configBluetooth();
    }
  }

  async updateSetting() {
    this.toggle = false;
    let filter = {};
    let outletInfo: any = [];
    if (localStorage.getItem('pos-order-outlet')) {
      const posOrderOutlet = JSON.parse(localStorage.getItem('pos-order-outlet') || '{}');
      if (posOrderOutlet && posOrderOutlet.id) {
        filter = { outlet_code: posOrderOutlet.outlet_code || posOrderOutlet.outletCode }
      }
    }
    this.fetching = true;
    await api
      .GetAllStoreForNewPort(
        { page: 1, size: 1 },
        { byField: '', isDesc: '' },
        filter,
        this.userUid
      )
      .then(res => {
        try {
          const data = res.data.result.data;
          if (data) {
            for (let index = 0; index < data.length; index++) {
              const element: any = data[index];
              outletInfo.push({
                outletType: element.type,
                value: element.outlet_code,
                text: element.outlet_code + ' - ' + element.name,
                ...element,
              });
            }
          }
        } catch (err) {
          this.fetching = false;
          return this.$swal(
            constants.SOMETHING_WROING,
            err.message,
            constants.STATUS_ERROR
          );
        }
      })
    if (outletInfo.length) {
      const data = outletInfo[0];
      localStorage.setItem('pos-order-outlet', JSON.stringify(data));
      localStorage.setItem('selected-outlet', JSON.stringify(data));

      await this.$store
        .dispatch('GetOneStoreForNewPort', data.id)
        .then((res) => {
          const data = res.data.result;
          localStorage.setItem('outletData', JSON.stringify(data));
          if (data) {
            this.$store.commit('UPDATE_EDC_MODEL', data.edc_model);
          } else {
            this.$store.commit('UPDATE_EDC_MODEL', false);
          }
        }).catch(err => {
          this.fetching = false;
          return this.$swal(
            constants.SOMETHING_WROING,
            err.message,
            constants.STATUS_ERROR
          );
        });
    }
    const outletCodes = localStorage
      .getItem('outletCodes')!
      .split(',')
      .filter(item => !!item);
    if (!this.isAdmin && outletCodes.length) {
      await api
        .GetAllStoreForNewPort(
          { page: 1, size: outletCodes.length },
          { byField: '', isDesc: '' },
          {},
          this.userUid
        )
        .then(res => {
          try {
            localStorage.setItem('outletList', JSON.stringify(res.data.result.data));
          } catch (error) {
            throw error;
          }
        });
    }
    window.location.reload();
  }

  listenScreenChange() {
    const { innerWidth: screenWidth } = window;
    if (screenWidth > 1336) {
      this.isMobile = false;
      sessionStorage.removeItem('isMobile');
    } else {
      this.isMobile = true;
      sessionStorage.setItem('isMobile', '1');
    }
  }
}
